import { useOrder } from "../state/order";

type Props = {
  maxTables?: number;
  className?: string;
};

export default function OrderMetaPanel({
  maxTables = 5,
  className = "",
}: Props) {
  const table = useOrder((s) => s.table);
  const persons = useOrder((s) => s.persons);
  const setTable = useOrder((s) => s.setTable);
  const setPersons = useOrder((s) => s.setPersons);

  return (
    <div
      className={`border rounded bg-white p-3 flex items-center justify-between gap-3 ${className}`}
    >
      <div className="flex items-center gap-3">
        <label className="text-sm text-gray-600">Стол</label>
        <select
          value={table ?? ""}
          onChange={(e) => setTable(Number(e.target.value))}
          className="h-9 border rounded px-2"
        >
          <option value="" disabled>
            Выбрать
          </option>
          {Array.from({ length: maxTables }, (_, i) => i + 1).map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm text-gray-600">Персон</label>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setPersons(Math.max(1, (persons ?? 1) - 1))}
            className="w-9 h-9 border rounded"
            aria-label="Уменьшить количество персон"
          >
            −
          </button>
          <input
            type="number"
            min={1}
            value={persons ?? 1}
            onChange={(e) =>
              setPersons(Math.max(1, Number(e.target.value) || 1))
            }
            className="w-16 h-9 border rounded text-center"
          />
          <button
            onClick={() => setPersons((persons ?? 1) + 1)}
            className="w-9 h-9 border rounded"
            aria-label="Увеличить количество персон"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}
